import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';

import { AppContextProvider } from './js/contexts/AppContext';
import { PageWrapper } from './js/wrappers/PageWrapper';

import { HomePage } from './js/components/home-page/HomePage';
import { AboutUsPage } from './js/components/about-us/AboutUsPage';
import { ServicesPage } from './js/components/services/ServicesPage';
import { ServicePage } from './js/components/services/ServicePage';
import { ContactPage } from './js/components/contact/ContactPage';



class RootPage extends Component {
  render(){
    return (
      <AppContextProvider>
        <BrowserRouter>
          <Switch>
            <Route exact path ='/' render={ () => <PageWrapper darkTheme homePage><HomePage/></PageWrapper> } />

            <Route exact path ='/about-us' render={ () => <PageWrapper><AboutUsPage/></PageWrapper> } />

            <Route exact path ='/services' render={ () => <PageWrapper><ServicesPage/></PageWrapper> } />
            <Route exact path ='/services/accounting' render={ () => <PageWrapper><ServicePage page='accounting'/></PageWrapper> } />
            <Route exact path ='/services/information' render={ () => <PageWrapper><ServicePage page='information'/></PageWrapper> } />
            <Route exact path ='/services/cooking' render={ () => <PageWrapper><ServicePage page='cooking'/></PageWrapper> } />
            <Route exact path ='/services/marathon-running' render={ () => <PageWrapper><ServicePage page='marathon-running'/></PageWrapper> } />

            <Route exact path ='/contact' render={ () => <PageWrapper><ContactPage/></PageWrapper> } />

            <Route path='/' render={() => <PageWrapper><div>404 page</div></PageWrapper>} />
          </Switch>
        </BrowserRouter>
      </AppContextProvider>
      
    )
  }
}

ReactDOM.render(<RootPage />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
